module.exports = __webpack_public_path__ + "img/5.5b65446d.jpg";